import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { TONE_TEXT, type Tone } from '../../lib/tone';
import { Icon, type LucideIcon } from '../ui/icon';

export interface SettingRowProps {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  /** Statuszeile, z. B. „Einrichtung nötig“ in warning. */
  status?: { tone: Tone; label: ReactNode };
  /** Button oder Switch rechts. */
  control?: ReactNode;
  /** Ohne Rahmen, innerhalb einer Card. */
  plain?: boolean;
  className?: string;
}

/**
 * Eine Einstellung oder Verbindung: Icon, Name, Beschreibung, optional Status, ein Bedienelement.
 * Wird es eng (am Handy, ein breiter Button), rückt das Bedienelement unter den
 * Text, statt ihn auf ein paar Zeichen je Zeile zu quetschen; ein Switch passt
 * meist noch daneben.
 */
export function SettingRow({ icon, title, description, status, control, plain, className }: SettingRowProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-2', plain ? 'py-3' : 'rounded-lg border border-border bg-card px-5 py-4', className)}>
      {icon && <Icon icon={icon} size={22} className="text-highlight" />}
      <div className="min-w-[min(100%,12rem)] flex-1">
        <div className={plain ? 't-body-strong' : 't-title'}>{title}</div>
        {description && <div className="t-small text-muted-foreground">{description}</div>}
        {status && <div className={cn('mt-0.5 t-small font-medium', TONE_TEXT[status.tone])}>{status.label}</div>}
      </div>
      {control && <div className="ml-auto flex items-center gap-2">{control}</div>}
    </div>
  );
}
